import { useState } from 'react'
import { NavLink } from 'react-router-dom'
import { useAuth } from '../../context/AuthContext'

const IconPOS        = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><rect x="2" y="3" width="20" height="14" rx="2"/><path d="M8 21h8M12 17v4"/></svg>
const IconCaja       = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 7V5a2 2 0 0 0-4 0v2M12 12v3M10 15h4"/></svg>
const IconCategorias = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/></svg>
const IconRecepcion  = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M22 12h-6l-2 3h-4l-2-3H2"/><path d="M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"/></svg>
const IconReportes   = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><rect x="3" y="3" width="18" height="18" rx="2"/><path d="M3 9h18M9 21V9"/></svg>
const IconProductos  = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/></svg>
const IconUsuarios   = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75"/></svg>
const IconClientes   = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
const IconMenu       = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><line x1="4" y1="6" x2="20" y2="6"/><line x1="4" y1="12" x2="20" y2="12"/><line x1="4" y1="18" x2="20" y2="18"/></svg>

export default function MobileNav() {
  const { usuario, logout } = useAuth()
  const [menuAbierto, setMenuAbierto] = useState(false)

  const p = usuario?.permisos || {}
  const esAdmin = p.administrador || usuario?.rol === 'admin'
  const iniciales = usuario?.nombre?.split(' ').map(n => n[0]).slice(0, 2).join('') || 'U'

  const cerrar = () => setMenuAbierto(false)

  // Ítems principales según permisos (mismo criterio que Sidebar.jsx)
  const principales = [
    { to: '/pos',       label: 'Vender',    icon: <IconPOS/>,       visible: p.ventas || esAdmin },
    { to: '/productos', label: 'Productos', icon: <IconProductos/>, visible: p.inventario || esAdmin },
    { to: '/reportes',  label: 'Reportes',  icon: <IconReportes/>,  visible: p.reportes || esAdmin },
    { to: '/caja',      label: 'Caja',      icon: <IconCaja/>,      visible: p.caja || esAdmin },
  ].filter(i => i.visible)

  // Máximo 3 en la barra; el resto va al menú "Más"
  const enBarra   = principales.slice(0, 3)
  const restantes = principales.slice(3)

  const secundarios = [
    ...restantes,
    { to: '/categorias', label: 'Categorías', icon: <IconCategorias/>, visible: p.inventario || esAdmin },
    { to: '/recepcion',  label: 'Recepción',  icon: <IconRecepcion/>,  visible: p.inventario || esAdmin },
    { to: '/clientes',   label: 'Clientes',   icon: <IconClientes/>,   visible: p.clientes || esAdmin },
    { to: '/usuarios',   label: 'Usuarios',   icon: <IconUsuarios/>,   visible: esAdmin },
  ].filter(i => i.visible)

  return (
    <>
      <nav className="mobile-nav">
        {enBarra.map(item => (
          <NavLink
            key={item.to}
            to={item.to}
            className={({ isActive }) => `mnav-item ${isActive ? 'active' : ''}`}
            onClick={cerrar}
          >
            {item.icon}
            <span>{item.label}</span>
          </NavLink>
        ))}
        <button
          className={`mnav-item ${menuAbierto ? 'active' : ''}`}
          onClick={() => setMenuAbierto(v => !v)}
        >
          <IconMenu/>
          <span>Más</span>
        </button>
      </nav>

      {menuAbierto && (
        <>
          <div className="mobile-menu-overlay" onClick={cerrar}/>
          <div className="mobile-menu-sheet">
            <button className="sheet-handle" onClick={cerrar} aria-label="Cerrar menú">
              <span/>
            </button>

            <nav style={{ marginBottom: 8 }}>
              {secundarios.map(item => (
                <NavLink
                  key={item.to + item.label}
                  to={item.to}
                  className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
                  onClick={cerrar}
                >
                  {item.icon} {item.label}
                </NavLink>
              ))}
              {secundarios.length === 0 && (
                <div style={{ padding: '12px 10px', fontSize: 13, color: 'var(--color-muted)' }}>
                  No tienes más módulos habilitados
                </div>
              )}
              {usuario?.rol === 'superadmin' && (
                <>
                  <NavLink
                    to="/superadmin"
                    onClick={cerrar}
                    style={{
                      display: 'flex', alignItems: 'center', gap: 6, padding: '10px 12px',
                      marginTop: 8, borderRadius: 6, fontSize: 12, fontWeight: 600,
                      background: '#1a1a2e', color: 'white', textDecoration: 'none'
                    }}
                  >
                    ⚙️ Panel Superadmin
                  </NavLink>
                  <NavLink
                    to="/suscripciones"
                    onClick={cerrar}
                    style={{
                      display: 'flex', alignItems: 'center', gap: 6, padding: '10px 12px',
                      marginTop: 8, borderRadius: 6, fontSize: 12, fontWeight: 600,
                      background: '#1a1a2e', color: 'white', textDecoration: 'none'
                    }}
                  >
                    💳 Suscripciones
                  </NavLink>
                </>
              )}
            </nav>

            <hr className="divider" style={{ margin: '10px 0' }}/>

            <div className="user-card">
              <div className="user-avatar">{iniciales}</div>
              <div className="user-info">
                <div className="user-name">{usuario?.nombre}</div>
                <div className="user-role">{usuario?.rol}</div>
              </div>
              <button
                onClick={logout}
                title="Cerrar sesión"
                style={{
                  display: 'flex', alignItems: 'center', gap: 5,
                  background: 'var(--color-danger-bg)',
                  border: '1px solid #f7c1c1',
                  borderRadius: 6,
                  cursor: 'pointer',
                  color: 'var(--color-danger)',
                  padding: '8px 12px',
                  fontSize: 12,
                  fontWeight: 600,
                  whiteSpace: 'nowrap',
                  flexShrink: 0,
                }}
              >
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4M16 17l5-5-5-5M21 12H9"/>
                </svg>
                Salir
              </button>
            </div>
          </div>
        </>
      )}
    </>
  )
}
